<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/gtmgr/select"
            :model="formModel"
            @openAddDialog="addInfo"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            addShowPower="/gtmgr/add"
        >
            <el-form-item label="名称" prop="typeName">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="formModel.typeName"
                    placeholder="请输入名称"
                ></el-input>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="typeName"
                label="名称"
                min-width="100"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="dictKey"
                label="字典key"
                min-width="100"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="dictValue"
                label="字典value"
                min-width="100"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="iconUrl"
                label="图标"
                min-width="100"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <div class="iconUrl" :style="'background:url(' + scope.row.iconUrl + ') center/cover no-repeat'"></div>
                </template>
            </el-table-column>
            <el-table-column
                prop="remark"
                label="备注"
                min-width="100"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" min-width="120">
                <template slot-scope="scope">
                    <el-button type="text" @click="addInfo(scope.row.id)">修改</el-button>
                    <el-button
                        type="text"
                        @click="deleInfo(scope.row.id)"
                        class="button-color"
                    >删除
                    </el-button
                    >
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            :formDialogTitle="formDialogTitle"
            :model="dialogModel"
            :dialogService="dialogService"
            :submitData="dialogData"
            :rules="dialogRules"
            class="over"
            @success="dialogSuccess"
            @close="dialogClose"
            @opend="dialogOpen"
            labelWidth="140px"
        >
            <el-form-item label="类型名称" prop="typeName">
                <el-input
                    type="text"
                    maxlength="20"
                    show-word-limit
                    v-model="dialogModel.typeName"
                    placeholder="请输入类型名称"
                ></el-input>
            </el-form-item>
            <el-form-item label="字典Key" prop="dictKey">
                <el-input
                    type="text"
                    maxlength="50"
                    show-word-limit
                    v-model="dialogModel.dictKey"
                    placeholder="请输入字典Key"
                ></el-input>
            </el-form-item>
            <el-form-item label="字典Value" prop="dictValue">
                <el-input
                    type="text"
                    maxlength="50"
                    show-word-limit
                    v-model="dialogModel.dictValue"
                    placeholder="请输入字典Value"
                ></el-input>
            </el-form-item>
            <el-form-item label="类型说明" prop="remark">
                <el-input
                    type="textarea"
                    resize="none"
                    rows="5"
                    maxlength="50"
                    show-word-limit
                    v-model="dialogModel.remark"
                    placeholder="请输入类型说明"
                ></el-input>
            </el-form-item>
            <el-form-item label="菜单图标" prop="permPath">
                <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl + '8883/picture/upload'"
                    :data="commonParams"
                    name="picture"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="dialogModel.iconUrl" :src="dialogModel.iconUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import FormDialog from "../../dialog/FormDialog";
    import SystemDicService from "service/SystemDicService";
    import Server from 'common/conf/Server';
    import privateKey from "service/constant/privateKey";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "dictionarymanage",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
        },
        data() {
            return {
                uploadUrl: Server[process.env.NODE_ENV],
                formModel: {
                    typeName: "",
                },
                params: {},
                page: {},
                tableData: [],
                submitService: SystemDicService.list,
                formDialogTitle: "",
                dialogModel: {
                    iconUrl: '',
                },
                dialogRules: {
                    typeName: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!value) {
                                    callback(new Error("请输入类型名称"));
                                } else if (this.checkChnNameOnly) {
                                    callback(new Error("类型名称或字典Key不能重复"));
                                } else {
                                    callback();
                                }
                            },
                        },
                    ],
                    dictKey: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!value) {
                                    callback(new Error("请输入字典Key"));
                                } else if (this.checkChnNameOnly) {
                                    callback(new Error("类型名称或字典Key不能重复"));
                                } else {
                                    callback();
                                }
                            },
                        },
                    ],
                    dictValue: [
                        {
                            required: true,
                            message: "请输入字典Value",
                        },
                    ],
                    remark: [
                        {
                            required: true,
                            message: "请输入类型说明",
                        },
                    ],
                },
                dictId: "",
                getTypeName: "",
                getDictKey: "",
                isPage: false,
            };
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getList();
        },
        computed: {
            commonParams() {
                const params = {
                    serverType: this.serverType,
                    tatId: this.tatId,
                    reqTime: new Date().format("yyyy-MM-dd HH:mm:ss")
                };
                params.sign = encrypt(urlEncode(objKeySort(params)) + '&priKey=' + privateKey.priKey);
                return params;
            },
            checkChnNameOnly() {
                for (let i = 0; i < this.tableData.length; i++) {
                    if (
                        this.dialogData.typeName == this.tableData[i].typeName &&
                        this.dialogData.dictKey == this.tableData[i].dictKey
                    ) {
                        if (
                            this.getTypeName == this.tableData[i].typeName &&
                            this.getDictKey == this.tableData[i].dictKey
                        ) {
                            return false;
                        }
                        return true;
                    } else {
                        if (i == this.tableData.length - 1) {
                            return false;
                        }
                    }
                }
            },
            dialogService() {
                if (this.dictId) {
                    return SystemDicService.update;
                } else {
                    return SystemDicService.add;
                }
            },
            dialogData() {
                const params = {
                    typeName: this.dialogModel.typeName,
                    dictKey: this.dialogModel.dictKey,
                    dictValue: this.dialogModel.dictValue,
                    remark: this.dialogModel.remark,
                    iconUrl: this.dialogModel.iconUrl,
                    userId: this.userId,
                };
                if (this.dictId) {
                    params.id = this.dictId;
                }
                return params;
            },
            submitData() {
                this.params = {
                    typeName: this.formModel.typeName.trim(),
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return this.params;
            },
            ...mapGetters(["serverType", "tatId", "userId"]),
        },
        methods: {
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    SystemDicService.list,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            const result = res.contents;
                            this.tableData = result.rows;
                            // console.log(result.rows)
                            this.page.currentPage = result.current;
                            this.page.total = result.total;
                            this.page.pageSize = result.size;
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            getDetail() {
                const detailParams = {
                    id: this.dictId,
                    userId: this.userId,
                };
                this.doLoad(
                    SystemDicService.detail,
                    detailParams,
                    (res) => {
                        this.doCheck(res, (res) => {
                            const result = res.contents;
                            this.dialogModel = result;
                            if (!this.dialogModel.iconUrl){
                                this.dialogModel.iconUrl = '';
                            }
                            this.getTypeName = this.dialogModel.typeName;
                            this.getDictKey = this.dialogModel.dictKey;
                        });
                    },
                    "信息获取失败"
                );
            },
            addInfo(id) {
                this.dictId = id;
                if (this.dictId) {
                    this.formDialogTitle = "修改字典";
                    this.getDetail();
                } else {
                    this.formDialogTitle = "添加字典";
                }
                this.$refs.formDialog.open();
            },
            onSuccess(data) {
                this.doCheck(data, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            dialogSuccess() {
                this.$refs.formDialog.closeDialog();
                this.dictId = "";
                this.getList();
            },
            dialogOpen() {
            },
            dialogClose() {
                this.dialogModel = {};
            },
            doDeleInfo(id) {
                const disabledParams = {
                    id: id,
                    status: 0,
                    userId: this.userId,
                };
                this.doLoad(
                    SystemDicService.dpStatus,
                    disabledParams,
                    (res) => {
                        this.doCheck(res, (res) => {
                            const result = res.contents;
                            this.showSuccess(result.optMsg);
                            this.getList();
                        });
                    },
                    "操作失败"
                );
            },
            deleInfo(id) {
                this.showConfirm("确定删除此字典？")
                    .then(() => {
                        this.doDeleInfo(id);
                    })
                    .catch(() => {
                    });
            },
            handleAvatarSuccess(res, file) {
                console.log(res);
                this.doCheck(res, res => {
                    this.dialogModel.iconUrl = res.contents;
                    console.log('this.dialogModel.iconUrl',this.dialogModel.iconUrl)
                })
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            }
        },
    };
</script>

<style scoped>
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }

    .avatar {
        width: 100px;
        height: 100px;
        display: block;
        border: 1px solid #d9d9d9;
    }
    .iconUrl {
        width: 50px;
        height: 50px;
        margin: auto;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/SystemManage/DictionaryManage.vue